import React from 'react'
import * as Types from '../../declarations'
import { getTrekImageAltText } from '../../lib/display'
import { useIsMobile } from '../../lib/useIsMobile'
import JustifiedGallery from './components/JustifiedGallery'
import PictureUploadButton from './components/PictureUploadButton'
import SectionHeader from './components/SectionHeader'

interface Props {
	trip: Types.DB.Models.TripAttributes
	onImageClick: (imageId: number) => void
}

const RemainingImagesGallery = ({
	trip: {
		name,
		uploads: allUploads,
		jsonData: { trekOrClimb },
	},
	trip: trek,
	onImageClick,
}: Props) => {
	const isMobile = useIsMobile()
	const allImages = (allUploads || []).filter(
		({ isDisplayedInGallery }) => isDisplayedInGallery,
	)
	const images = React.useMemo(
		() =>
			isMobile && allImages.length > 0
				? allImages.slice(1)
				: allImages.length > 4
				? allImages.slice(5)
				: allImages.slice(1),
		[isMobile, allImages],
	)

	if (images.length === 0) return <></>

	const altText = getTrekImageAltText(trek)

	return (
		<div className="spacing-between-sections-above">
			<SectionHeader
				title={`Pictures from ${
					trekOrClimb === 'CLIMB' ? 'climbing' : 'trekking'
				} ${name}`}
				section={Types.App.DataTypes.FeedbackSection.PICTURES}
			/>
			<p>
				These are pictures taken while{' '}
				{trekOrClimb === 'CLIMB' ? 'climbing' : 'trekking'} {name}. They&apos;re
				shown here to give you an idea of what the route is like. You&apos;re
				welcome to share your own pictures of{' '}
				{trekOrClimb === 'CLIMB' ? 'climbing' : 'hiking'} {name}, to help the
				community of {trekOrClimb === 'CLIMB' ? 'climbers' : 'hikers'}. Picture
				here are either uploaded by members (their own, or creative commons
				pictures), or guides.
			</p>
			<JustifiedGallery
				pictures={images}
				size="small"
				altText={altText}
				onImageClick={onImageClick}
			/>
			<PictureUploadButton />
		</div>
	)
}

export default RemainingImagesGallery
